import { render, staticRenderFns } from "./rematch_raceManagement.vue?vue&type=template&id=ddb4c66e&scoped=true"
import script from "./rematch_raceManagement.vue?vue&type=script&lang=js"
export * from "./rematch_raceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb4c66e",
  null
  
)

export default component.exports